'use strict';
const mmWidgets = require('./mm-widgets'),
	ColorHelper = require('../models/color-helper'),
	foregroundStyle = require('@mindmup/mapjs-core/src/theme/foreground-style'),
	calculateStyles = function (color, nodeTheme) {
		const colorText = nodeTheme && nodeTheme.borderType !== 'surround';
		if (colorText) {
			return {
				text: {
					color: color
				},
				backgroundColor: false,
				background: false
			};
		} else {
			return {
				text: {
					color: color && nodeTheme && nodeTheme.text[foregroundStyle(color)]
				},
				backgroundColor: color,
				background: false
			};
		}
	};

require('./typeahead');


mmWidgets.fn.keyboardColorWidget = function (mapModel, mapEditorModel, themeProvider) {
	return mmWidgets.each(this, function () {
		const widget = this,
			colorHelper = new ColorHelper(),
			changeColor = function (val) {
				const color = val && colorHelper.validColor(val.toLowerCase()),
					nodeTheme = themeProvider.getNodeTheme(mapModel.getSelectedNodeId());
				if (color || val === 'default') {
					mapEditorModel.updateNodeStyles(calculateStyles(color, nodeTheme));
					widget.addClass('hidden');
				}
			},
			formatTemplate = function (item, currentValue/*, searchString*/) {
				item.find('[data-mm-role=color]').css('background-color', currentValue);
				item.find('[data-mm-role=content]').text(currentValue);
			};
		return widget.typeahead(colorHelper.findColor, changeColor, formatTemplate);
	});
};
